import { useEffect, useState } from "react";
import {FormattedDate} from "react-intl";


  const CurrentTimeDisplay = ({ year, month, weekday, day, hour, minute }: Intl.DateTimeFormatOptions) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const scheduleNextTick = () => {
      const msUntilNextMinute = 60000 - (Date.now() % 60000);
      timeoutId = setTimeout(() => {
        setTime(new Date());
        scheduleNextTick();
      }, msUntilNextMinute);
    };
    scheduleNextTick();
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <FormattedDate
      value={time}
      year={year}
      month={month}
      weekday={weekday}
      day={day}
      hour={hour}
      minute={minute}
    />
  );
};

export default CurrentTimeDisplay;
